import { memo } from 'react';
import { useTheme } from '@mui/material';
import SideIllustrationLight from './side.svg?react';
import SideIllustrationDark from './side_dark.svg?react';

export const SideIllustration = memo((props: React.SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  if (theme.palette.type === 'dark')
    return <SideIllustrationDark aria-hidden="true" {...props} />;
  return <SideIllustrationLight aria-hidden="true" {...props} />;
});
